import React from 'react';
import styled from 'styled-components';
import HeaderEs from '../common/header/HeaderEs';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { reqEsDetailInfoAction } from '../../modules/od/orderModule';
import EsReqDvryInfoWait from './EsReqDvryInfoWait';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import { delEsItemAction } from '../../modules/es/esItemModule';
import moment from "moment";
import {
    EsReqMustGuide, EsReqDvryInfo, EsReqDvryGuide,
    EsReqRefund,EsComItemList, EsComSummary
}
    from './'
import {isMobileOnly} from 'react-device-detect';


// Modal Stryle
export const EsReqStopPopupModalStyles = {
    content: {
        padding: isMobileOnly?"0":"20px",
        /* top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)', */
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 'auto',
        postion: 'fixed',


        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "100%",
        height: "100%",
        borderRadius: '0px',
        backgroundColor: '#fff',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }
};

const EsReqStopPopupBlock = styled.div`
  ${isMobileOnly&&`margin: 0 4vw;`};
  .mobile-header {margin:40px; text-align: center;}

`;

const EsReqStopMobileWrapBlock = styled.div`
    padding-bottom: 170px;
    // .splitter {border-bottom: 2px solid #ececec; padding-bottom:10px;}
    .product-table {
      margin: 10px 0;
      border-top: 2px solid #111;  
    }
`;
const EsReqStopWrapBlock = styled.div`
    padding: 98px 0 179px;  
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const EsReqStopPopup = ({ esItem, onCloseClick }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [msg, setMsg] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format, rqst_status } = esItem[0];

    var { esItemDetailInfo, nickname } = useSelector(
        ({ esOrderReducer, userReducer }) => ({
            esItemDetailInfo: esOrderReducer.esItemDetailInfo,
            nickname: userReducer.nickname,
        })
    );

    const getCaseNum = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){
                if(esItemDetailInfo.masterinfo.es_suspend_type === '055401'){
                    return 'CASE 01.';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055402'){
                    return 'CASE 02.';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055403'){
                    return 'CASE 03.';
                }
            }
        }

        return 'CASE'
    }

    const getCaseTitle = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){
                if(esItemDetailInfo.masterinfo.es_suspend_type === '055401'){
                    return '자재 수급 불가';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055402'){
                    return '배송 불가 지역';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055403'){
                    return '기타 사유';
                }
            }
        }

        return ''
    }

    const getSuspand = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                let text = "";
                if(esItemDetailInfo.masterinfo.es_suspend_msg !== null && typeof(esItemDetailInfo.masterinfo.es_suspend_msg) === "string" && esItemDetailInfo.masterinfo.es_suspend_msg.length > 0){
                    text = esItemDetailInfo.masterinfo.es_suspend_msg.replace(nickname+'님','<b>' +'“' + nickname + '”님' +  '</b>');
                    text = text.replace(brnd_han,'<b>' +'“' + brnd_han + '”' +  '</b>');
                    text = text.replace(/\n/g,'</br>');
                }
                else {
                    text = esItemDetailInfo.masterinfo.es_suspend_msg;
                }
                //let text = esItemDetailInfo.masterinfo.es_suspend_msg
                return text;
            }
        }

        return "";
    }

    const getCompleteDate = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.es_send_date !== null  && esItemDetailInfo.masterinfo.es_send_date !== undefined){

                    return moment(esItemDetailInfo.masterinfo.es_send_date).format('YYYY년 MM월 DD일');
                }
            }
        }

        return "";
    }

    useEffect(() => {
        dispatch(reqEsDetailInfoAction(es_rqst_id))
    }, [])

    // Delete 처리
    const handleClickDelBtn = () => {
        setMsg("견적서를 삭제하시겠어요?");
        setOpenModal(true);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        dispatch(delEsItemAction(es_rqst_id));
        setOpenModal(false);
        onCloseClick();
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const statusMsg = <div className="es_apply_info-box" style={{ marginTop: '-40px' }}>
        <p className="eai-title margin_b-10">
            위와 같은 사유로 견적이 중단됩니다.
        </p>
        지속적인 관심 부탁드려요 👍<br/>
        {/* <p className="ess_text margin_b-30">
                        ※ 유효기간이 지난 견적서는 자동으로 중단으로 상태가 바뀜을 알려드립니다.
                    </p> */}
        {/* <p className="margin_b-10">
            견적 요청일 :
            <span className="font-mont">{rqst_date_format}</span>
        </p> */}
        <p className="margin_t-20 margin_b-10">
            중단일 :
            <span className="font-mont"> {getCompleteDate()}</span>
        </p>
    </div>

    return (<EsReqStopPopupBlock>
          {isMobileOnly?
            <div className="flex vc fe">
                <div className="mobile-header title-xl font-bold margin_b-40 margin_t-40 flex-1 text_center">{brnd_han}</div>
                < i className="fas fa-times fa-2x" onClick={onCloseClick}/>
            </div>
            :
            <HeaderEs
              rqst_id={es_rqst_id} name={brnd_han}
              onCloseClick={onCloseClick}
            />
          }
          {isMobileOnly ?
            <EsReqStopMobileWrapBlock>
                <div className="title-xl margin_b-10 text_center">
                    견적중단 안내
                </div>
                <div className="title-lg margin_b-30 text_center">{pckg_nm}</div>

                <div className="margin_b-80">
                    <div className="default-table pink pink-title">
                        <h3 className="stop-title margin_b-20">
                            <span className="dotted-tag red font-mont">{getCaseNum()}</span>
                            &nbsp;{getCaseTitle()}
                        </h3>

                        <table>
                            <tbody>
                            <tr>
                                <td className="gray text_center">
                                    <div dangerouslySetInnerHTML={{ __html: getSuspand() }}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="margin_b-80">
                    <EsComItemList items={esItem}/>
                </div>
                <EsComSummary item={esItem[0]} type="responsive"/>

                <div  className="margin_b-30" />
                <EsReqDvryInfo detailInfo={esItemDetailInfo}
                               dsrd_date_format={dsrd_date_format} rqst_status={rqst_status}/>
                {statusMsg}

            </EsReqStopMobileWrapBlock>
            :
            <EsReqStopWrapBlock>
                <div className="es_title-box margin_b-50">
                    <h3 className="es_title">
                        <span><b style={{ fontWeight: '500' }}>{nickname}</b></span> 님께<br/>
                        <span><b style={{ fontWeight: '500' }}>{pckg_nm}</b></span>에 대한 견적 안내
                    </h3>
                </div>
                <div className="margin_b-80">
                    <div className="default-table pink pink-title">
                        <h3 className="stop-title margin_b-20">
                            <span className="dotted-tag red font-mont">{getCaseNum()}</span>
                            &nbsp;{getCaseTitle()}
                        </h3>

                        <table>
                            <tbody>
                            <tr>
                                <td className="gray text_center">
                                    <div dangerouslySetInnerHTML={{ __html: getSuspand() }}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="margin_b-80">
                    <div className="filter-top myes_top clearfix">
                        <span className="f-left">견적 요청일 <span className="font-mont">{rqst_date_format}</span></span>
                    </div>

                    <div className="product-table default-table">
                        <table>
                            <colgroup>
                                <col width="120px;"/>
                                <col width="710px;"/>
                                <col width="124px;"/>
                                <col width="221px;"/>
                            </colgroup>

                            <thead>
                            <tr>
                                <th colSpan="2">상품 정보</th>
                                <th>수량</th>
                                <th>판매금액</th>
                            </tr>
                            </thead>
                            <tbody>
                            <EsComItemList items={esItem}/>
                            </tbody>
                            <EsComSummary item={esItem[0]} type="tableTr"/>
                        </table>
                    </div>

                    <EsReqDvryInfoWait detailInfo={esItemDetailInfo}
                                       rqst_date_format={rqst_date_format} rqst_status={rqst_status}/>

                    {statusMsg}
                </div>

            </EsReqStopWrapBlock>
          }

        {/* <div className="full_popup_btn-wrap">
                <button type="button" className="mh-btn black-btn" onClick={handleClickDelBtn}>견적 취소</button>
        </div> */}
        <Modal
            isOpen={openModal}
            onRequestClose={handleModalClose}
            style={customModalStyles}
            onAfterOpen={() => document.body.style.overflow = 'hidden'}
            onAfterClose={() => document.body.removeAttribute('style')}>
            {
                <NormalPopup
                    text=""
                    text2={msg}
                    btn1="예" btn2="아니오"
                    onClick1={handleModalBtn1Click}
                    onClick2={handleModalBtn2Click} />
            }

        </Modal>
    </EsReqStopPopupBlock>
    );
};

export default EsReqStopPopup;
